module.exports = __webpack_public_path__ + "static/media/download.e1e354e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/download.svg
// module id = 389
// module chunks = 0